import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    background-color: ${theme.colors.white};

    .checkbox_container {
      display: flex;
      margin-top: 25px;
      justify-content: space-between;
    }

    .button-container {
      display: flex;
      justify-content: end;
      margin-top: 20px;
      margin-bottom: 20px;
    }
  `}
`
